function Header() {
  return (
    <header className="header header-minimal">
      <nav className="header-fixed" style={{ backgroundColor: "var(--text-primary)", color: "var(--background-color)" }}>
        <div className="container">
          <div className="row flex-nowrap align-items-center justify-content-between">
            <div className="col-auto header-fixed-col logo-wrapper">
              <a href="/" className="logo" title="AM Systems">
                <img src="/images/logo-navbar.png" width="115" height="36" alt="AM Systems" />
              </a>
            </div>
            <div className="col-auto col-xl col-static header-fixed-col d-none d-xl-block">
              <div className="row flex-nowrap align-items-center justify-content-end">
                <div className="col header-fixed-col d-none d-xl-block col-static">
                  <nav className="main-mnu">
                    <ul className="main-mnu-list">
                      <li>
                        <a href="#intro" data-title="Início" style={{ color: "var(--background-color)" }}>
                          <span>Início</span>
                        </a>
                      </li>
                      <li>
                        <a href="#services" data-title="Serviços" style={{ color: "var(--background-color)" }}>
                          <span>Serviços</span>
                        </a>
                      </li>
                      <li>
                        <a href="#choose" data-title="Diferenciais" style={{ color: "var(--background-color)" }}>
                          <span>Diferenciais</span>
                        </a>
                      </li>
                      <li>
                        <a href="#contact-form" data-title="Contato" style={{ color: "var(--background-color)" }}>
                          <span>Contato</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <div className="col-auto d-block d-xl-none header-fixed-col">
              <div className="main-mnu-btn">
                <span className="bar bar-1" style={{ backgroundColor: "var(--background-color)" }}></span>
                <span className="bar bar-2" style={{ backgroundColor: "var(--background-color)" }}></span>
                <span className="bar bar-3" style={{ backgroundColor: "var(--background-color)" }}></span>
                <span className="bar bar-4" style={{ backgroundColor: "var(--background-color)" }}></span>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
